<template>
  <div class="gallery">
    <div class="container">
      <div class="row justify-content-center d-flex d-md-none">
        <div class="col-md-12 col-lg-10 col-xl-8">
          <iframe width="100%" height="300" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div class="row">
        <div
          class="col-6 col-md-4"
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.length - 1"
          :key="index"
          :class="{ 'full-mobile col-12' :  gallery.length - 1 === index }"
        >
          <div class="d-flex flex-wrap row justify-content-center">
            <div
              class="col-12"
              v-for="(image, imageIndex) in images"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <v-lazy-image :src="image.thumbnail"/>
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center d-md-flex d-none">
        <div class="col-md-12 col-lg-10 col-xl-8">
          <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="control left" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="control right" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <v-lazy-image :src="preview.full" class="img-fluid"/>
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by <a :href="preview.copyright.link || null">{{ preview.copyright.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ThImageL1 from "@/assets/images/gallery/SAP_8874.jpg";
import ThImageL2 from "@/assets/images/gallery/DSC07650.jpg";
import ThImageL3 from "@/assets/images/gallery/SAP_9060.jpg";
import ThImageL4 from "@/assets/images/gallery/SAP_8649.jpg";
import ThImageL5 from "@/assets/images/gallery/SAP_8671.jpg";
import ThImageL6 from "@/assets/images/gallery/SAP_9030.jpg";
import ThImageL7 from "@/assets/images/gallery/l10.jpg";
import ThImageL8 from "@/assets/images/gallery/l2.jpg";

import ThImagePOne from "@/assets//images/gallery/SAP_8968p.jpg";
import ThImagePTwo from "@/assets//images/gallery/SAP_8693.jpg";
import ThImagePThree from "@/assets//images/gallery/DSC07448.jpg";
import ThImageP4 from "@/assets//images/gallery/DSC07568-2.jpg";


import ImagePOne from "@/assets//images/gallery/SAP_8968p_l.jpg";
import ImagePTwo from "@/assets//images/gallery/SAP_8693_l.jpg";
import ImageL2 from "@/assets/images/gallery/DSC07650.jpg";
import ImageL3 from "@/assets/images/gallery/SAP_9060_l.jpg";
import ImageL4 from "@/assets/images/gallery/SAP_8649_l.jpg";
import ImageL5 from "@/assets/images/gallery/SAP_8671_l.jpg";
import ImageL6 from "@/assets/images/gallery/SAP_9030_l.jpg";

import VLazyImage from "v-lazy-image";
import Slick from "vue-slick";

export default {
  components: {
    VLazyImage,
    Slick
  },
  data() {
    return {
      slickOpt: {
        slideToShow: 1
      },
      gallery: [
        [
          {
            thumbnail: ThImageL1,
            full: ThImageL1,
            transition: "fade-down-right",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImagePOne,
            full: ImagePOne,
            transition: "fade-right",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImageL2,
            full: ImageL2,
            transition: "fade-up-right",
            copyright: {
              name: 'Dodi Pratama',
              link: 'https://www.instagram.com/pt.dodi'
            },
          }
        ],
        [
          {
            thumbnail: ThImagePTwo,
            full: ImagePTwo,
            transition: "fade-down-left",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImageL3,
            full: ImageL3,
            transition: "fade-left",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImageL4,
            full: ImageL4,
            transition: "fade-up-left",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          }
        ],
        [
          {
            thumbnail: ThImageL5,
            full: ImageL5,
            transition: "fade-down-right",
            class: "order-1 order-lg-1",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImageL6,
            full: ImageL6,
            transition: "fade-right",
            class: "order-2 order-lg-2",
            copyright: {
              name: 'Satria Photo',
              link: 'https://www.instagram.com/satriaphoto'
            },
          },
          {
            thumbnail: ThImagePThree,
            full: ThImagePThree,
            transition: "fade-up-right",
            class: "order-3 order-lg-3",
            copyright: {
              name: 'Dodi Pratama',
              link: 'https://www.instagram.com/pt.dodi'
            },
          }
        ]
      ],
      preview: null
    };
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    }
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach(items => {
        images.push(...items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map(item => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    }
  },
  watch: {
    preview() {
      if(this.preview === null) {
        document.querySelector('body').style.overflowY = null;
      } else {
        document.querySelector('body').style.overflowY = 'hidden';
      }
    }
  }
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
